/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Country } from '@app/settings/countries/countries.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CountriesService } from '@app/settings/countries/countries.service';
import { Logger } from '@app/core';

const log = new Logger('CountriesFormComponent');

@Component({
  selector: 'app-countries-form',
  templateUrl: './countries-form.component.html',
  styleUrls: ['./countries-form.component.scss'],
})
export class CountriesFormComponent implements OnInit {
  @Input() country: Country = null;

  form: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private countryService: CountriesService
  ) {}

  ngOnInit() {
    this.createForm();
  }

  save() {
    if (this.country && this.country.id) {
      const country: Country = this.country.deserialize(this.form.value);
      this.countryService.update(country).subscribe((res) => this.modal.close('Save click'));
    } else {
      const country: Country = new Country().deserialize(this.form.value);
      this.countryService.store(country).subscribe((res) => this.modal.close(res));
    }
  }

  test() {
    log.debug(this.form);
  }

  private createForm() {
    log.debug('createForm');
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]],
      code: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      phone_code: [null, [Validators.required]],
      timezone: [null, [Validators.required]],
      active: [true],
    });

    if (this.country && this.country.id) {
      this.countryService.show(this.country.id).subscribe((country: Country) => {
        this.form.patchValue(country);
      });
    } else if (this.country) {
      this.form.patchValue(this.country);
    }
  }
}
